import { render, staticRenderFns } from "./PhotoTour.vue?vue&type=template&id=57b015dc&"
import script from "./PhotoTour.vue?vue&type=script&lang=js&"
export * from "./PhotoTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports